import * as yup from 'yup';

export const categoryNumberValidator = yup
  .string()
  .nullable()
  .test('costCodeNumber', 'Cost Category Number cannot be zero', (val) => {
    return val !== '0';
  })
  .max(7, 'Length cannot be more than 6')
  .required('Required field')
  .matches(
    /^[A-Za-z0-9\.-]+$/,
    'Must be 1–6 characters long. Letters, numbers, dashes, and decimal values are supported.'
  )
  .test('not-seven-digits', 'Cannot be more than 6 digits', (value) => {
    if (!value) return true;
    return !(value.length === 7 && /^\d{7}$/.test(value));
  });

export const costCodeNumberValidator = yup
  .string()
  .nullable()
  .max(7, 'Length cannot be more than 6')
  .required('Required field')
  .matches(
    /^[A-Za-z0-9\.-]+$/,
    'Must be 1–6 characters long. Letters, numbers, dashes, and decimal values are supported.'
  )
  .test('not-seven-digits', 'Cannot be more than 6 digits', (value) => {
    if (!value) return true;
    return !(value.length === 7 && /^\d{7}$/.test(value));
  });
